import { gql } from '@apollo/client';

export default gql`
  mutation pageView($pathname: String!, $referrer: String) {
    pageView(pathname: $pathname, referrer: $referrer)
  }
`; 